/* global requestAnimationFrame: false */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Alert } from 'react-native';

import { View } from 'react-native';

import {
  Animated,
  TextInput as NativeTextInput,
} from 'react-native';

import pickFromStyle from '../../../utils/pick-from-style';

import Label from './label';
import Underline from './underline';
import Text, { getStyles } from '../text';
import { PALETTE } from '../../../constants';

var type = 'text-input';

class TextInput extends PureComponent {
  constructor(props) {
    super(props);
    this.inputFrame = {};
    this.anim = null;
    this.state = {
      inputMarginTop: 0,
      measured: false,
      hide : true, /*added this to hide the label float*/
    };

    this.doMeasurement = this.doMeasurement.bind(this);
    this.handleInputMeasured = this.handleInputMeasured.bind(this);
    this.handleLabelMeasured = this.handleLabelMeasured.bind(this);
    this.handleChangeText = this.handleChangeText.bind(this);
    this.handleFocus = this.handleFocus.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.handleClear = this.handleClear.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
  }

  componentWillMount() {
    this.setBufferedValue(this.props.value || this.props.defaultValue);
    this.originalPlaceholder = this.props.placeholder;
  }

  componentDidMount() {
    requestAnimationFrame(this.doMeasurement);
    // ReactDOM.findDOMNode(this.refs.textInput).focus();
  }

  componentWillUnmount() {
        type = 'text-input';
    }

  componentWillReceiveProps(nextProps) {
    const newText = nextProps.value || nextProps.defaultValue;
    if (newText !== undefined) {
      this.setBufferedValue(newText);
    }

    if (nextProps.error !== this.props.error) {
      if (nextProps.error) {
        this.animationStartHighlight(!this.isFocused(), false);
      } else {
        this.animationStopHighlight();
      }
    }

    this.originalPlaceholder = nextProps.placeholder;
  }

  setPlaceholder(placeholder) {
    if (this.input) {
      this.input.setNativeProps({ placeholder });
    }
  }

  setBufferedValue(v) {
    this.bufferedValue = v;
    /*commented the float anim remove it to rollback*/
    // if (v) {
    //   this.animationFloatLabel();
    // }
  }

  getBufferedValue() {
    return (this.bufferedValue || '').trim();
  }

  focus() {
    if (this.input) {
      // this.setState({ hide : true });
      this.input.focus();
    }
  }

  isFocused() {
    return this.input && this.input.isFocused();
  }

  blur() {
    if (this.input) {
      if(this.getBufferedValue() === '' ){
        this.setState({ hide : false });
      }
      this.input.blur();
    }
  }

  onKeyPress() {
    if(this.input){
      this.input.onKeyPress();
    }
  }


  handleKeyPress(e){
    const { nativeEvent: { key } } = e;
    this.safeCallback('onKeyPress', key);
  }

  handleChangeText(e) {
    let text = e.target.value;
    this.setBufferedValue(text);
    this.safeCallback('onChangeText', text);
    this.forceUpdate();
    if(text.length > 0){
      type = 'text-input active';
    } else {
      type = 'text-input';
    }
  }

  handleFocus(e) {
    this.setState({ hide : true });
    this.animationStartHighlight(!this.props.error, true);
    this.safeCallback('onFocus', e);
    let text = e.target.value;
    type = 'text-input active';
  }

  handleBlur(e) {
    if(this.getBufferedValue() === '' ){
        this.setState({ hide : false });
        this.forceUpdate();
     }
    this.animationStopHighlight();
    this.safeCallback('onBlur', e);
    let text = e.target.value;
    if(text.length <= 0){
      type = 'text-input';
    }
  }

  startAnimations(animations, cb) {
    if (this.anim) {
      this.anim.stop();
    }

    this.anim = Animated.parallel(animations).start(cb);
  }

  doMeasurement() {
    if (this.input) {
      this.input.measure(this.handleInputMeasured);
      if (this.props.labelEnabled) {
        this.label.measure(this.handleLabelMeasured);
      }
    }
  }

  handleLabelMeasured(labelHeight) {
    this.setState({
      inputMarginTop: labelHeight,
      measured: true,
    });
  }

  handleInputMeasured(left, top, width, height) {
    Object.assign(this.inputFrame, { left, top, width, height });
    this.underline.updateLineLength(width, () => {
      if (this.getBufferedValue() || this.isFocused()) {
        this.animationStartHighlight(this.isFocused());
      }
    });
  }

  animationFloatLabel() {
    if (!(this.getBufferedValue() && this.props.labelEnabled)) {
      return;
    }

    if (this.label) {
      const animations = this.label.animationFloatLabel();
      if (animations.length) {
        this.startAnimations(animations);
      }
    }
  }

  animationStartHighlight(focused, floatLabel) {
    const animations = this.underline.animationStretchUnderline(focused);

    if (floatLabel && this.props.labelEnabled && this.label) {
      animations.push(...this.label.animationFloatLabel());
    }

    if (animations.length) {
      this.startAnimations(animations);
    }
    this.forceUpdate();
  }

  animationStopHighlight() {
    const animations = this.underline.animationShrinkUnderline();

    if (this.props.labelEnabled && !this.bufferedValue && this.label) {
      animations.push(...this.label.animationSinkLabel());
    }

     if (this.props.labelEnabled) {
          this.setPlaceholder(this.originalPlaceholder);
        }
    if (animations.length) {
      this.startAnimations(animations, () => {
        if (this.props.labelEnabled) {
          this.setPlaceholder(this.originalPlaceholder);
        }
      });
    }
  }

  safeCallback(name, e) {
    if (this.props[name]) {
      this.props[name](e);
    }
  }



  handleClear() {
    this.input.clear();
    this.handleChangeText('');
  }

  render() {
    // const underlineProps = extractProps(this, Underline.propTypes);
    // const inputProps = extractProps(this, NativeTextInput.propTypes);

    const inputStyles = getStyles({
      ...this.props,
      style: this.props.textInputStyle,
    });

    const { fontSize } = pickFromStyle(inputStyles, 'fontSize');
    const inputMarginBottom = 7;
    const inputHeight = ((fontSize * 2) + inputMarginBottom)-1;
    //const inputViewHeight = inputHeight + inputMarginBottom + 0;




    return (
      <div>
        <div className={type}>
          <label>{this.props.placeholder}</label>
          <input
            type={this.props.fieldType}
            ref="textInput"
            style={{
              fontSize,
              height: inputHeight,
              backgroundColor: 'transparent',
              color: this.props.textColor,
              paddingRight: 20,
              marginBottom: 5,
              borderTop: 0,
              borderLeft: 0,
              borderRight: 0,
              borderColor: 'gray',
            }}
            onChange={this.handleChangeText}
            onKeyUp={this.handleKeyPress}
            onFocus={this.handleFocus}
            onBlur={this.handleBlur}
            autoCorrect={false}
            maxLength="30"
            autoComplete="off"
            id={this.props.placeholder}
          />
        </div>
        <Underline
          ref={r => { this.underline = r; }}
        />
        {this.props.error ? <div id={this.props.errorText} className="errorColor">{this.props.errorText}</div> :null}
      </div>
    );
  }
}

TextInput.propTypes = {
  ...NativeTextInput.propTypes,
  ...Text.propTypes,
  ...Label.publicPropTypes,
  ...Underline.propTypes,
  labelSize: Text.propTypes.size.isRequired,
  labelColor: PropTypes.string.isRequired,
  labelStyles: PropTypes.number,
  textColor: PropTypes.string.isRequired,
  selectionColor: PropTypes.string.isRequired,
  allowFontScaling: PropTypes.bool,
};

TextInput.defaultProps = {
  labelEnabled: true,
  underlineEnabled: true,
  size: 'large',
  labelSize: 'small',
  placeholderTextColor: PALETTE.primaryText,
  textColor: PALETTE.primaryText,
  selectionColor: PALETTE.primaryText,
  labelColor: PALETTE.primaryText,
  underlineColor: PALETTE.secondaryText,
  underlineActiveColor: PALETTE.primaryText,
  underlineSize: 1,
  errorColor: PALETTE.errorColor,
  returnKeyType: 'next',
  labelHide : true,
};

export default TextInput;
